// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modern Split-Screen Login Page */
.modern-login-page {
  height: 100vh;
  width: 100vw;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
}
/* Ensure child elements don't exceed container */
.modern-login-page * {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
}
/* Left Side - Marketing Section */
.marketing-section {
  -webkit-box-flex: 1;
      -ms-flex: 1;
          flex: 1;
  min-width: 0; /* Allow flex item to shrink below content size */
  background: linear-gradient(178.7deg, #EEEEFD 1.11%, rgba(238, 238, 253, 0) 103.22%);
  padding: 2.5rem 3.75rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  position: relative;
  overflow: hidden;
  height: 100vh;
}
.marketing-content {
  max-width: 31.25rem;
  z-index: 2;
  -ms-flex-negative: 1;
      flex-shrink: 1;
  width: 100%;
}
/* Marketing Logo */
.marketing-logo {
  margin-bottom: 2.5rem;
}
.photon-logo-container.large {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 0.75rem;
}
.photon-logo-dots {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.1875rem;
  width: 2.5rem;
  height: 2.5rem;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  justify-items: center;
}
.photon-logo-dots > div {
  width: 0.75rem !important;
  height: 0.75rem !important;
}
.photon-logo-container.small .photon-logo-dots {
  width: 1.5rem;
  height: 1.5rem;
}
.photon-logo-container.small .photon-logo-dots > div {
  width: 0.375rem !important;
  height: 0.375rem !important;
}
.photon-logo-text {
  font-family: Inter;
  font-weight: 700;
  font-size: 1.5rem;
  line-height: 1.75rem;
  letter-spacing: 0.04px;
  color: #1f2937;
}
/* Dot animations */
.dot-animation {
  -webkit-animation: pulse 2s infinite;
          animation: pulse 2s infinite;
}
.dot-1 { -webkit-animation-delay: 0s; animation-delay: 0s; }
.dot-2 { -webkit-animation-delay: 0.2s; animation-delay: 0.2s; }
.dot-3 { -webkit-animation-delay: 0.4s; animation-delay: 0.4s; }
.dot-4 { -webkit-animation-delay: 0.6s; animation-delay: 0.6s; }
.dot-5 { -webkit-animation-delay: 0.8s; animation-delay: 0.8s; }
.dot-6 { -webkit-animation-delay: 1.0s; animation-delay: 1.0s; }
.dot-7 { -webkit-animation-delay: 1.2s; animation-delay: 1.2s; }
.dot-8 { -webkit-animation-delay: 1.4s; animation-delay: 1.4s; }
@-webkit-keyframes pulse {
  0%, 100% {
    opacity: 1;
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  50% {
    opacity: 0.5;
    -webkit-transform: scale(1.2);
            transform: scale(1.2);
  }
}
@keyframes pulse {
  0%, 100% {
    opacity: 1;
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  50% {
    opacity: 0.5;
    -webkit-transform: scale(1.2);
            transform: scale(1.2);
  }
}
/* Color classes for dots */
.bg-red-500 { background-color: #ef4444; }
.bg-teal-500 { background-color: #14b8a6; }
.bg-blue-500 { background-color: #3b82f6; }
.bg-yellow-500 { background-color: #eab308; }
.bg-purple-500 { background-color: #a855f7; }
.bg-pink-500 { background-color: #ec4899; }
.bg-green-500 { background-color: #22c55e; }
.bg-orange-500 { background-color: #f97316; }
.login-rounded-full { border-radius: 50%; }
.w-2 { width: 0.5rem; }
.h-2 { height: 0.5rem; }
/* Marketing Heading */
.marketing-heading {
  margin-bottom: 1.25rem;
}
.marketing-heading h1 {
  margin: 0;
  line-height: 2.625rem;
  letter-spacing: 0.04px;
  font-size: 2.25rem;
  font-weight: 800;
  font-family: Inter;
}
.gradient-text {
  background: -webkit-gradient(linear, left top, right top, from(#2F80FF), color-stop(87.5%, #9617FA));
  background: linear-gradient(90deg, #2F80FF 0%, #9617FA 87.5%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
.black-text {
  color: #000000;
}
/* Marketing Subtitle */
.marketing-subtitle {
  font-family: Inter;
  font-weight: 400;
  font-size: 0.9375rem;
  line-height: 1.375rem;
  letter-spacing: 0.04px;
  color: #666666;
  margin-bottom: 2rem;
}
/* Medical Images Grid */
.medical-images-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.75rem;
  margin-bottom: 0;
}
.medical-image-placeholder {
  aspect-ratio: 1;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 0.75rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  border: 1px solid rgba(0, 0, 0, 0.1);
  -webkit-transition: -webkit-transform 0.2s ease;
  transition: -webkit-transform 0.2s ease;
  transition: transform 0.2s ease;
  transition: transform 0.2s ease, -webkit-transform 0.2s ease;
  overflow: hidden;
}
.medical-image-placeholder img {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
     object-fit: cover;
}
.medical-image-placeholder:hover {
  -webkit-transform: translateY(-0.125rem);
          transform: translateY(-0.125rem);
  -webkit-box-shadow: 0 0.25rem 1.25rem rgba(0, 0, 0, 0.1);
          box-shadow: 0 0.25rem 1.25rem rgba(0, 0, 0, 0.1);
}
.image-content {
  font-size: 1.5rem;
  opacity: 0.7;
}
/* Decorative Elements */
.decorative-elements {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 1;
}
.dots-pattern {
  position: absolute;
  width: 3.75rem;
  height: 3.75rem;
  opacity: 0.3;
}
.dots-pattern::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: radial-gradient(circle at 50% 50%, #2F80FF 0.125rem, transparent 0.125rem);
  background-size: 1.25rem 1.25rem;
}
.dots-pattern-1 {
  top: 20%;
  right: 10%;
}
.dots-pattern-2 {
  bottom: 30%;
  left: 5%;
}
.wave-shape {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 12.5rem;
  height: 6.25rem;
  background: linear-gradient(45deg, rgba(47, 128, 255, 0.1), rgba(150, 23, 250, 0.1));
  border-radius: 100% 0 0 100%;
  opacity: 0.5;
}
/* Right Side - Login Section */
.login-section {
  -webkit-box-flex: 1;
      -ms-flex: 1;
          flex: 1;
  min-width: 0; /* Allow flex item to shrink below content size */
  background: #FFFFFF;
  padding: 3.75rem 5rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  min-height: 100vh;
}
.login-content {
  width: 100%;
  max-width: 25rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  height: 100%;
}
.login-logo {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  margin-bottom: 1.25rem;
}
.login-form-container {
  /* Remove card styling - form now uses the section background */
  background: transparent;
  padding: 0;
  border-radius: 0;
  -webkit-box-shadow: none;
          box-shadow: none;
  border: none;
  -webkit-box-flex: 1;
      -ms-flex: 1;
          flex: 1;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}
/* Login Title */
.login-title {
  font-family: Inter;
  font-weight: 600;
  font-size: 1.875rem;
  line-height: 3.125rem;
  letter-spacing: 0.04px;
  color: #1f2937;
  text-align: center;
  margin-bottom: 2rem !important;
}
/* Modern Form Styling */
.modern-login-form {
  margin: 0;
}
.modern-login-form .ant-form-item-label > label {
  font-family: Inter, sans-serif;
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 1.25rem;
  letter-spacing: 0px;
  color: #374151;
  margin-bottom: 0.375rem;
}
.modern-input {
  width: 100%;
  height: 3rem;
  border-radius: 0.5rem;
  padding: 0.75rem 1rem;
  border: 1px solid #D1D5DB;
  font-size: 0.875rem;
  -webkit-transition: border-color 0.2s, -webkit-box-shadow 0.2s;
  transition: border-color 0.2s, -webkit-box-shadow 0.2s;
  transition: border-color 0.2s, box-shadow 0.2s;
  transition: border-color 0.2s, box-shadow 0.2s, -webkit-box-shadow 0.2s;
}
/* Override browser autofill styling */
.modern-input:-webkit-autofill,
.modern-input:-webkit-autofill:hover,
.modern-input:-webkit-autofill:focus,
.modern-input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 1.875rem white inset !important;
          box-shadow: 0 0 0 1.875rem white inset !important;
  -webkit-text-fill-color: #374151 !important;
}
/* For Ant Design Input wrapper */
.ant-input:-webkit-autofill,
.ant-input:-webkit-autofill:hover,
.ant-input:-webkit-autofill:focus,
.ant-input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 1.875rem white inset !important;
          box-shadow: 0 0 0 1.875rem white inset !important;
  -webkit-text-fill-color: #374151 !important;
}
/* For Ant Design Input with prefix (username field) */
.ant-input-affix-wrapper input:-webkit-autofill,
.ant-input-affix-wrapper input:-webkit-autofill:hover,
.ant-input-affix-wrapper input:-webkit-autofill:focus,
.ant-input-affix-wrapper input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 1.875rem white inset !important;
          box-shadow: 0 0 0 1.875rem white inset !important;
  -webkit-text-fill-color: #374151 !important;
}
/* For other browsers */
.modern-input:autofill,
.ant-input:autofill {
  background-color: white !important;
  color: #374151 !important;
}
.modern-input:hover {
  border-color: #7D48B0;
}
.modern-input:focus {
  border-color: #7D48B0;
  -webkit-box-shadow: 0 0 0 0.1875rem rgba(125, 72, 176, 0.1);
          box-shadow: 0 0 0 0.1875rem rgba(125, 72, 176, 0.1);
}
.input-icon {
  color: #9CA3AF;
  margin-right: 0.5rem;
}
/* Gradient Button */
.gradient-button {
  height: 3rem;
  border: none;
  border-radius: 0.5rem;
  background: -webkit-gradient(linear, left top, right top, from(#7D48B0), to(#9617FA));
  background: linear-gradient(90deg, #7D48B0 0%, #9617FA 100%);
  font-weight: 600;
  font-size: 1rem;
  margin-top: 1.5rem;
  -webkit-transition: -webkit-transform 0.2s, -webkit-box-shadow 0.2s;
  transition: -webkit-transform 0.2s, -webkit-box-shadow 0.2s;
  transition: transform 0.2s, box-shadow 0.2s;
  transition: transform 0.2s, box-shadow 0.2s, -webkit-transform 0.2s, -webkit-box-shadow 0.2s;
}
.gradient-button:hover {
  -webkit-transform: translateY(-0.0625rem);
          transform: translateY(-0.0625rem);
  -webkit-box-shadow: 0 0.25rem 1rem rgba(125, 72, 176, 0.4);
          box-shadow: 0 0.25rem 1rem rgba(125, 72, 176, 0.4);
  background: -webkit-gradient(linear, left top, right top, from(#7D48B0), to(#9617FA)) !important;
  background: linear-gradient(90deg, #7D48B0 0%, #9617FA 100%) !important;
  color: white !important;
}
.gradient-button:focus {
  background: -webkit-gradient(linear, left top, right top, from(#7D48B0), to(#9617FA)) !important;
  background: linear-gradient(90deg, #7D48B0 0%, #9617FA 100%) !important;
  color: white !important;
}
/* Login Footer */
.login-footer {
  text-align: center;
  margin-top: 1.5rem;
  font-size: 0.875rem;
  color: #6B7280;
}
.support-link {
  color: #2563EB;
  text-decoration: none;
  font-weight: 500;
}
.support-link:hover {
  color: #1D4ED8;
  text-decoration: underline;
}
/* Alert Styling */
.login-alert {
  margin-bottom: 1.5rem;
  border-radius: 0.5rem;
}
/* Password input specific styling */
.ant-input-password {
  height: 3rem;
  border-radius: 0.5rem;
  border: 1px solid #D1D5DB;
}
.ant-input-password:hover {
  border-color: #7D48B0;
}
/* Override autofill for password inputs */
.ant-input-password input:-webkit-autofill,
.ant-input-password input:-webkit-autofill:hover,
.ant-input-password input:-webkit-autofill:focus,
.ant-input-password input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 1.875rem white inset !important;
          box-shadow: 0 0 0 1.875rem white inset !important;
  -webkit-text-fill-color: #374151 !important;
}
.ant-input-password-icon {
  color: #9CA3AF;
}
/* Responsive Design */
@media (max-width: 1400px) {
  .marketing-section {
    padding: 2.5rem 2.5rem;
  }

  .login-section {
    padding: 2.5rem 2.5rem;
  }

  .marketing-content {
    max-width: 31.25rem;
  }

  .marketing-heading h1 {
    font-size: 2.25rem;
    line-height: 2.75rem;
  }
}
@media (max-width: 1200px) {
  .marketing-section {
    padding: 1.875rem 1.875rem;
  }

  .login-section {
    padding: 1.875rem 1.875rem;
  }

  .marketing-content {
    max-width: 28.125rem;
  }

  .marketing-heading h1 {
    font-size: 2rem;
    line-height: 2.5rem;
  }

  /* .login-form-container padding removed since it's now transparent */
}
@media (max-width: 968px) {
  .modern-login-page {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    position: relative; /* Remove fixed positioning on mobile */
    height: auto;
    min-height: 100vh;
  }

  /* Hide marketing section on smaller screens - prioritize login functionality */
  .marketing-section {
    display: none;
  }

  .login-section {
    -webkit-box-flex: 0;
        -ms-flex: none;
            flex: none;
    min-height: 100vh;
    padding: 2.5rem 2.5rem;
    width: 100%;
  }

  .login-title {
    font-size: 1.5rem !important;
    line-height: 2rem !important;
  }
}
@media (max-width: 576px) {
  /* Marketing section already hidden by previous media query */
  .marketing-section {
    display: none;
  }

  .login-section {
    padding: 1.875rem 1.25rem;
    min-height: 100vh;
  }

  .login-title {
    font-size: 1.375rem !important;
    line-height: 1.75rem !important;
  }
}
/* Form item specific overrides */
.modern-login-form .ant-form-item {
  margin-bottom: 1.25rem;
}
.modern-login-form .ant-form-item-label {
  padding-bottom: 0.25rem;
}
.login-actions {
  margin-bottom: 0 !important;
}
/* Input focus states */
.ant-input-affix-wrapper:focus,
.ant-input-affix-wrapper-focused {
  border-color: #7D48B0;
  -webkit-box-shadow: 0 0 0 0.1875rem rgba(125, 72, 176, 0.1);
          box-shadow: 0 0 0 0.1875rem rgba(125, 72, 176, 0.1);
}
`, "",{"version":3,"sources":["webpack://./pages/login/login.css"],"names":[],"mappings":"AAAA,mCAAmC;AACnC;EACE,aAAa;EACb,YAAY;EACZ,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,MAAM;EACN,OAAO;EACP,8BAAsB;UAAtB,sBAAsB;AACxB;AAEA,iDAAiD;AACjD;EACE,8BAAsB;UAAtB,sBAAsB;AACxB;AAEA,kCAAkC;AAClC;EACE,mBAAO;MAAP,WAAO;UAAP,OAAO;EACP,YAAY,EAAE,iDAAiD;EAC/D,oFAAoF;EACpF,uBAAuB;EACvB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,oBAAc;MAAd,cAAc;EACd,WAAW;AACb;AAEA,mBAAmB;AACnB;EACE,qBAAqB;AACvB;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,YAAY;AACd;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;EACd,aAAa;EACb,cAAc;EACd,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,qBAAqB;AACvB;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;AAEA;EACE,aAAa;EACb,cAAc;AAChB;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,cAAc;AAChB;AAEA,mBAAmB;AACnB;EACE,oCAA4B;UAA5B,4BAA4B;AAC9B;AAEA,SAAS,2BAAmB,EAAnB,mBAAmB,EAAE;AAC9B,SAAS,6BAAqB,EAArB,qBAAqB,EAAE;AAChC,SAAS,6BAAqB,EAArB,qBAAqB,EAAE;AAChC,SAAS,6BAAqB,EAArB,qBAAqB,EAAE;AAChC,SAAS,6BAAqB,EAArB,qBAAqB,EAAE;AAChC,SAAS,6BAAqB,EAArB,qBAAqB,EAAE;AAChC,SAAS,6BAAqB,EAArB,qBAAqB,EAAE;AAChC,SAAS,6BAAqB,EAArB,qBAAqB,EAAE;AAEhC;EACE;IACE,UAAU;IACV,2BAAmB;YAAnB,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,6BAAqB;YAArB,qBAAqB;EACvB;AACF;AATA;EACE;IACE,UAAU;IACV,2BAAmB;YAAnB,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,6BAAqB;YAArB,qBAAqB;EACvB;AACF;AAEA,2BAA2B;AAC3B,cAAc,yBAAyB,EAAE;AACzC,eAAe,yBAAyB,EAAE;AAC1C,eAAe,yBAAyB,EAAE;AAC1C,iBAAiB,yBAAyB,EAAE;AAC5C,iBAAiB,yBAAyB,EAAE;AAC5C,eAAe,yBAAyB,EAAE;AAC1C,gBAAgB,yBAAyB,EAAE;AAC3C,iBAAiB,yBAAyB,EAAE;AAC5C,sBAAsB,kBAAkB,EAAE;AAC1C,OAAO,aAAa,EAAE;AACtB,OAAO,cAAc,EAAE;AAEvB,sBAAsB;AACtB;EACE,sBAAsB;AACxB;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;AAEA;EACE,oGAA6D;EAA7D,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;AAEA;EACE,cAAc;AAChB;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;AACrB;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;EACZ,gBAAgB;AAClB;AAEA;EACE,eAAe;EACf,oCAAoC;EACpC,sBAAsB;EACtB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,oCAAoC;EACpC,+CAA+B;EAA/B,uCAA+B;EAA/B,+BAA+B;EAA/B,4DAA+B;EAC/B,gBAAgB;AAClB;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAiB;KAAjB,iBAAiB;AACnB;AAEA;EACE,wCAAgC;UAAhC,gCAAgC;EAChC,wDAAgD;UAAhD,gDAAgD;AAClD;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oBAAoB;EACpB,UAAU;AACZ;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,YAAY;AACd;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,4FAA4F;EAC5F,gCAAgC;AAClC;AAEA;EACE,QAAQ;EACR,UAAU;AACZ;AAEA;EACE,WAAW;EACX,QAAQ;AACV;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,cAAc;EACd,eAAe;EACf,oFAAoF;EACpF,4BAA4B;EAC5B,YAAY;AACd;AAEA,+BAA+B;AAC/B;EACE,mBAAO;MAAP,WAAO;UAAP,OAAO;EACP,YAAY,EAAE,iDAAiD;EAC/D,mBAAmB;EACnB,qBAAqB;EACrB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,iBAAiB;AACnB;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,YAAY;AACd;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,sBAAsB;AACxB;AAEA;EACE,+DAA+D;EAC/D,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,wBAAgB;UAAhB,gBAAgB;EAChB,YAAY;EACZ,mBAAO;MAAP,WAAO;UAAP,OAAO;EACP,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,8BAA8B;AAChC;AAEA,wBAAwB;AACxB;EACE,SAAS;AACX;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,uBAAuB;AACzB;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,8DAA8C;EAA9C,sDAA8C;EAA9C,8CAA8C;EAA9C,uEAA8C;AAChD;AAEA,sCAAsC;AACtC;;;;EAKE,yDAAiD;UAAjD,iDAAiD;EACjD,2CAA2C;AAC7C;AAEA,iCAAiC;AACjC;;;;EAKE,yDAAiD;UAAjD,iDAAiD;EACjD,2CAA2C;AAC7C;AAEA,sDAAsD;AACtD;;;;EAKE,yDAAiD;UAAjD,iDAAiD;EACjD,2CAA2C;AAC7C;AAEA,uBAAuB;AACvB;;EAEE,kCAAkC;EAClC,yBAAyB;AAC3B;AAEA;EACE,qBAAqB;AACvB;AAEA;EACE,qBAAqB;EACrB,2DAAmD;UAAnD,mDAAmD;AACrD;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;AAEA,oBAAoB;AACpB;EACE,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,qFAA4D;EAA5D,4DAA4D;EAC5D,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mEAA2C;EAA3C,2DAA2C;EAA3C,2CAA2C;EAA3C,4FAA2C;AAC7C;AAEA;EACE,yCAAiC;UAAjC,iCAAiC;EACjC,0DAAkD;UAAlD,kDAAkD;EAClD,gGAAuE;EAAvE,uEAAuE;EACvE,uBAAuB;AACzB;AAEA;EACE,gGAAuE;EAAvE,uEAAuE;EACvE,uBAAuB;AACzB;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;AAEA,kBAAkB;AAClB;EACE,qBAAqB;EACrB,qBAAqB;AACvB;AAEA,oCAAoC;AACpC;EACE,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;AAC3B;AAEA;EACE,qBAAqB;AACvB;AAEA,0CAA0C;AAC1C;;;;EAKE,yDAAiD;UAAjD,iDAAiD;EACjD,2CAA2C;AAC7C;AAEA;EACE,cAAc;AAChB;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;AACF;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA,qEAAqE;AACvE;AAEA;EACE;IACE,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,kBAAkB,EAAE,uCAAuC;IAC3D,YAAY;IACZ,iBAAiB;EACnB;;EAEA,+EAA+E;EAC/E;IACE,aAAa;EACf;;EAEA;IACE,mBAAU;QAAV,cAAU;YAAV,UAAU;IACV,iBAAiB;IACjB,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,4BAA4B;IAC5B,4BAA4B;EAC9B;AACF;AAEA;EACE,6DAA6D;EAC7D;IACE,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;EACnB;;EAEA;IACE,8BAA8B;IAC9B,+BAA+B;EACjC;AACF;AAEA,iCAAiC;AACjC;EACE,sBAAsB;AACxB;AAEA;EACE,uBAAuB;AACzB;AAEA;EACE,2BAA2B;AAC7B;AAEA,uBAAuB;AACvB;;EAEE,qBAAqB;EACrB,2DAAmD;UAAnD,mDAAmD;AACrD","sourcesContent":["/* Modern Split-Screen Login Page */\r\n.modern-login-page {\r\n  height: 100vh;\r\n  width: 100vw;\r\n  display: flex;\r\n  overflow: hidden;\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* Ensure child elements don't exceed container */\r\n.modern-login-page * {\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* Left Side - Marketing Section */\r\n.marketing-section {\r\n  flex: 1;\r\n  min-width: 0; /* Allow flex item to shrink below content size */\r\n  background: linear-gradient(178.7deg, #EEEEFD 1.11%, rgba(238, 238, 253, 0) 103.22%);\r\n  padding: 2.5rem 3.75rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  position: relative;\r\n  overflow: hidden;\r\n  height: 100vh;\r\n}\r\n\r\n.marketing-content {\r\n  max-width: 31.25rem;\r\n  z-index: 2;\r\n  flex-shrink: 1;\r\n  width: 100%;\r\n}\r\n\r\n/* Marketing Logo */\r\n.marketing-logo {\r\n  margin-bottom: 2.5rem;\r\n}\r\n\r\n.photon-logo-container.large {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.photon-logo-dots {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, 1fr);\r\n  gap: 0.1875rem;\r\n  width: 2.5rem;\r\n  height: 2.5rem;\r\n  align-items: center;\r\n  justify-items: center;\r\n}\r\n\r\n.photon-logo-dots > div {\r\n  width: 0.75rem !important;\r\n  height: 0.75rem !important;\r\n}\r\n\r\n.photon-logo-container.small .photon-logo-dots {\r\n  width: 1.5rem;\r\n  height: 1.5rem;\r\n}\r\n\r\n.photon-logo-container.small .photon-logo-dots > div {\r\n  width: 0.375rem !important;\r\n  height: 0.375rem !important;\r\n}\r\n\r\n.photon-logo-text {\r\n  font-family: Inter;\r\n  font-weight: 700;\r\n  font-size: 1.5rem;\r\n  line-height: 1.75rem;\r\n  letter-spacing: 0.04px;\r\n  color: #1f2937;\r\n}\r\n\r\n/* Dot animations */\r\n.dot-animation {\r\n  animation: pulse 2s infinite;\r\n}\r\n\r\n.dot-1 { animation-delay: 0s; }\r\n.dot-2 { animation-delay: 0.2s; }\r\n.dot-3 { animation-delay: 0.4s; }\r\n.dot-4 { animation-delay: 0.6s; }\r\n.dot-5 { animation-delay: 0.8s; }\r\n.dot-6 { animation-delay: 1.0s; }\r\n.dot-7 { animation-delay: 1.2s; }\r\n.dot-8 { animation-delay: 1.4s; }\r\n\r\n@keyframes pulse {\r\n  0%, 100% {\r\n    opacity: 1;\r\n    transform: scale(1);\r\n  }\r\n  50% {\r\n    opacity: 0.5;\r\n    transform: scale(1.2);\r\n  }\r\n}\r\n\r\n/* Color classes for dots */\r\n.bg-red-500 { background-color: #ef4444; }\r\n.bg-teal-500 { background-color: #14b8a6; }\r\n.bg-blue-500 { background-color: #3b82f6; }\r\n.bg-yellow-500 { background-color: #eab308; }\r\n.bg-purple-500 { background-color: #a855f7; }\r\n.bg-pink-500 { background-color: #ec4899; }\r\n.bg-green-500 { background-color: #22c55e; }\r\n.bg-orange-500 { background-color: #f97316; }\r\n.login-rounded-full { border-radius: 50%; }\r\n.w-2 { width: 0.5rem; }\r\n.h-2 { height: 0.5rem; }\r\n\r\n/* Marketing Heading */\r\n.marketing-heading {\r\n  margin-bottom: 1.25rem;\r\n}\r\n\r\n.marketing-heading h1 {\r\n  margin: 0;\r\n  line-height: 2.625rem;\r\n  letter-spacing: 0.04px;\r\n  font-size: 2.25rem;\r\n  font-weight: 800;\r\n  font-family: Inter;\r\n}\r\n\r\n.gradient-text {\r\n  background: linear-gradient(90deg, #2F80FF 0%, #9617FA 87.5%);\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n  background-clip: text;\r\n}\r\n\r\n.black-text {\r\n  color: #000000;\r\n}\r\n\r\n/* Marketing Subtitle */\r\n.marketing-subtitle {\r\n  font-family: Inter;\r\n  font-weight: 400;\r\n  font-size: 0.9375rem;\r\n  line-height: 1.375rem;\r\n  letter-spacing: 0.04px;\r\n  color: #666666;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n/* Medical Images Grid */\r\n.medical-images-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, 1fr);\r\n  gap: 0.75rem;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.medical-image-placeholder {\r\n  aspect-ratio: 1;\r\n  background: rgba(255, 255, 255, 0.8);\r\n  border-radius: 0.75rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border: 1px solid rgba(0, 0, 0, 0.1);\r\n  transition: transform 0.2s ease;\r\n  overflow: hidden;\r\n}\r\n\r\n.medical-image-placeholder img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n}\r\n\r\n.medical-image-placeholder:hover {\r\n  transform: translateY(-0.125rem);\r\n  box-shadow: 0 0.25rem 1.25rem rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.image-content {\r\n  font-size: 1.5rem;\r\n  opacity: 0.7;\r\n}\r\n\r\n/* Decorative Elements */\r\n.decorative-elements {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  pointer-events: none;\r\n  z-index: 1;\r\n}\r\n\r\n.dots-pattern {\r\n  position: absolute;\r\n  width: 3.75rem;\r\n  height: 3.75rem;\r\n  opacity: 0.3;\r\n}\r\n\r\n.dots-pattern::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-image: radial-gradient(circle at 50% 50%, #2F80FF 0.125rem, transparent 0.125rem);\r\n  background-size: 1.25rem 1.25rem;\r\n}\r\n\r\n.dots-pattern-1 {\r\n  top: 20%;\r\n  right: 10%;\r\n}\r\n\r\n.dots-pattern-2 {\r\n  bottom: 30%;\r\n  left: 5%;\r\n}\r\n\r\n.wave-shape {\r\n  position: absolute;\r\n  bottom: 0;\r\n  right: 0;\r\n  width: 12.5rem;\r\n  height: 6.25rem;\r\n  background: linear-gradient(45deg, rgba(47, 128, 255, 0.1), rgba(150, 23, 250, 0.1));\r\n  border-radius: 100% 0 0 100%;\r\n  opacity: 0.5;\r\n}\r\n\r\n/* Right Side - Login Section */\r\n.login-section {\r\n  flex: 1;\r\n  min-width: 0; /* Allow flex item to shrink below content size */\r\n  background: #FFFFFF;\r\n  padding: 3.75rem 5rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-height: 100vh;\r\n}\r\n\r\n.login-content {\r\n  width: 100%;\r\n  max-width: 25rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n}\r\n\r\n.login-logo {\r\n  display: flex;\r\n  justify-content: center;\r\n  margin-bottom: 1.25rem;\r\n}\r\n\r\n.login-form-container {\r\n  /* Remove card styling - form now uses the section background */\r\n  background: transparent;\r\n  padding: 0;\r\n  border-radius: 0;\r\n  box-shadow: none;\r\n  border: none;\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n}\r\n\r\n/* Login Title */\r\n.login-title {\r\n  font-family: Inter;\r\n  font-weight: 600;\r\n  font-size: 1.875rem;\r\n  line-height: 3.125rem;\r\n  letter-spacing: 0.04px;\r\n  color: #1f2937;\r\n  text-align: center;\r\n  margin-bottom: 2rem !important;\r\n}\r\n\r\n/* Modern Form Styling */\r\n.modern-login-form {\r\n  margin: 0;\r\n}\r\n\r\n.modern-login-form .ant-form-item-label > label {\r\n  font-family: Inter, sans-serif;\r\n  font-weight: 500;\r\n  font-size: 0.875rem;\r\n  line-height: 1.25rem;\r\n  letter-spacing: 0px;\r\n  color: #374151;\r\n  margin-bottom: 0.375rem;\r\n}\r\n\r\n.modern-input {\r\n  width: 100%;\r\n  height: 3rem;\r\n  border-radius: 0.5rem;\r\n  padding: 0.75rem 1rem;\r\n  border: 1px solid #D1D5DB;\r\n  font-size: 0.875rem;\r\n  transition: border-color 0.2s, box-shadow 0.2s;\r\n}\r\n\r\n/* Override browser autofill styling */\r\n.modern-input:-webkit-autofill,\r\n.modern-input:-webkit-autofill:hover,\r\n.modern-input:-webkit-autofill:focus,\r\n.modern-input:-webkit-autofill:active {\r\n  -webkit-box-shadow: 0 0 0 1.875rem white inset !important;\r\n  box-shadow: 0 0 0 1.875rem white inset !important;\r\n  -webkit-text-fill-color: #374151 !important;\r\n}\r\n\r\n/* For Ant Design Input wrapper */\r\n.ant-input:-webkit-autofill,\r\n.ant-input:-webkit-autofill:hover,\r\n.ant-input:-webkit-autofill:focus,\r\n.ant-input:-webkit-autofill:active {\r\n  -webkit-box-shadow: 0 0 0 1.875rem white inset !important;\r\n  box-shadow: 0 0 0 1.875rem white inset !important;\r\n  -webkit-text-fill-color: #374151 !important;\r\n}\r\n\r\n/* For Ant Design Input with prefix (username field) */\r\n.ant-input-affix-wrapper input:-webkit-autofill,\r\n.ant-input-affix-wrapper input:-webkit-autofill:hover,\r\n.ant-input-affix-wrapper input:-webkit-autofill:focus,\r\n.ant-input-affix-wrapper input:-webkit-autofill:active {\r\n  -webkit-box-shadow: 0 0 0 1.875rem white inset !important;\r\n  box-shadow: 0 0 0 1.875rem white inset !important;\r\n  -webkit-text-fill-color: #374151 !important;\r\n}\r\n\r\n/* For other browsers */\r\n.modern-input:autofill,\r\n.ant-input:autofill {\r\n  background-color: white !important;\r\n  color: #374151 !important;\r\n}\r\n\r\n.modern-input:hover {\r\n  border-color: #7D48B0;\r\n}\r\n\r\n.modern-input:focus {\r\n  border-color: #7D48B0;\r\n  box-shadow: 0 0 0 0.1875rem rgba(125, 72, 176, 0.1);\r\n}\r\n\r\n.input-icon {\r\n  color: #9CA3AF;\r\n  margin-right: 0.5rem;\r\n}\r\n\r\n/* Gradient Button */\r\n.gradient-button {\r\n  height: 3rem;\r\n  border: none;\r\n  border-radius: 0.5rem;\r\n  background: linear-gradient(90deg, #7D48B0 0%, #9617FA 100%);\r\n  font-weight: 600;\r\n  font-size: 1rem;\r\n  margin-top: 1.5rem;\r\n  transition: transform 0.2s, box-shadow 0.2s;\r\n}\r\n\r\n.gradient-button:hover {\r\n  transform: translateY(-0.0625rem);\r\n  box-shadow: 0 0.25rem 1rem rgba(125, 72, 176, 0.4);\r\n  background: linear-gradient(90deg, #7D48B0 0%, #9617FA 100%) !important;\r\n  color: white !important;\r\n}\r\n\r\n.gradient-button:focus {\r\n  background: linear-gradient(90deg, #7D48B0 0%, #9617FA 100%) !important;\r\n  color: white !important;\r\n}\r\n\r\n/* Login Footer */\r\n.login-footer {\r\n  text-align: center;\r\n  margin-top: 1.5rem;\r\n  font-size: 0.875rem;\r\n  color: #6B7280;\r\n}\r\n\r\n.support-link {\r\n  color: #2563EB;\r\n  text-decoration: none;\r\n  font-weight: 500;\r\n}\r\n\r\n.support-link:hover {\r\n  color: #1D4ED8;\r\n  text-decoration: underline;\r\n}\r\n\r\n/* Alert Styling */\r\n.login-alert {\r\n  margin-bottom: 1.5rem;\r\n  border-radius: 0.5rem;\r\n}\r\n\r\n/* Password input specific styling */\r\n.ant-input-password {\r\n  height: 3rem;\r\n  border-radius: 0.5rem;\r\n  border: 1px solid #D1D5DB;\r\n}\r\n\r\n.ant-input-password:hover {\r\n  border-color: #7D48B0;\r\n}\r\n\r\n/* Override autofill for password inputs */\r\n.ant-input-password input:-webkit-autofill,\r\n.ant-input-password input:-webkit-autofill:hover,\r\n.ant-input-password input:-webkit-autofill:focus,\r\n.ant-input-password input:-webkit-autofill:active {\r\n  -webkit-box-shadow: 0 0 0 1.875rem white inset !important;\r\n  box-shadow: 0 0 0 1.875rem white inset !important;\r\n  -webkit-text-fill-color: #374151 !important;\r\n}\r\n\r\n.ant-input-password-icon {\r\n  color: #9CA3AF;\r\n}\r\n\r\n/* Responsive Design */\r\n@media (max-width: 1400px) {\r\n  .marketing-section {\r\n    padding: 2.5rem 2.5rem;\r\n  }\r\n\r\n  .login-section {\r\n    padding: 2.5rem 2.5rem;\r\n  }\r\n\r\n  .marketing-content {\r\n    max-width: 31.25rem;\r\n  }\r\n\r\n  .marketing-heading h1 {\r\n    font-size: 2.25rem;\r\n    line-height: 2.75rem;\r\n  }\r\n}\r\n\r\n@media (max-width: 1200px) {\r\n  .marketing-section {\r\n    padding: 1.875rem 1.875rem;\r\n  }\r\n\r\n  .login-section {\r\n    padding: 1.875rem 1.875rem;\r\n  }\r\n\r\n  .marketing-content {\r\n    max-width: 28.125rem;\r\n  }\r\n\r\n  .marketing-heading h1 {\r\n    font-size: 2rem;\r\n    line-height: 2.5rem;\r\n  }\r\n\r\n  /* .login-form-container padding removed since it's now transparent */\r\n}\r\n\r\n@media (max-width: 968px) {\r\n  .modern-login-page {\r\n    flex-direction: column;\r\n    position: relative; /* Remove fixed positioning on mobile */\r\n    height: auto;\r\n    min-height: 100vh;\r\n  }\r\n\r\n  /* Hide marketing section on smaller screens - prioritize login functionality */\r\n  .marketing-section {\r\n    display: none;\r\n  }\r\n\r\n  .login-section {\r\n    flex: none;\r\n    min-height: 100vh;\r\n    padding: 2.5rem 2.5rem;\r\n    width: 100%;\r\n  }\r\n\r\n  .login-title {\r\n    font-size: 1.5rem !important;\r\n    line-height: 2rem !important;\r\n  }\r\n}\r\n\r\n@media (max-width: 576px) {\r\n  /* Marketing section already hidden by previous media query */\r\n  .marketing-section {\r\n    display: none;\r\n  }\r\n\r\n  .login-section {\r\n    padding: 1.875rem 1.25rem;\r\n    min-height: 100vh;\r\n  }\r\n\r\n  .login-title {\r\n    font-size: 1.375rem !important;\r\n    line-height: 1.75rem !important;\r\n  }\r\n}\r\n\r\n/* Form item specific overrides */\r\n.modern-login-form .ant-form-item {\r\n  margin-bottom: 1.25rem;\r\n}\r\n\r\n.modern-login-form .ant-form-item-label {\r\n  padding-bottom: 0.25rem;\r\n}\r\n\r\n.login-actions {\r\n  margin-bottom: 0 !important;\r\n}\r\n\r\n/* Input focus states */\r\n.ant-input-affix-wrapper:focus,\r\n.ant-input-affix-wrapper-focused {\r\n  border-color: #7D48B0;\r\n  box-shadow: 0 0 0 0.1875rem rgba(125, 72, 176, 0.1);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
